import tracker from '../utils/reports/TrackingService';
import dynamicTranslation from '../utils/translation/DynamicTranslationService';
import { configureStore } from './configureStore';

/**
 * @param {*} initialState
 * @returns {import('redux').Store}
 */
const initStoreAndServices = (initialState = {}) => {
    const store = configureStore(initialState);

    tracker.initialize(store);
    dynamicTranslation.addIndustriesTranslations(initialState?.dynamicTranslations);

    return store;
};

export { configureStore, initStoreAndServices };
